import type { FaqItem } from "@/components/sections/products/shared/faq/types";
import { DOCS, ROUTES, STATS, TRUSTPILOT_URL } from "@/lib/constants";
import { STATS_IPS_DE } from "@/components/sections/de/shared/stats-de";

// German translation of RESIDENTIAL_PRODUCT_FAQS (same 15 questions, same hrefs).
export const RESIDENTIAL_PRODUCT_FAQS_DE: FaqItem[] = [
  {
    q: "Was sind Residential Proxies?",
    a: "Residential Proxies leiten den Datenverkehr über IP-Adressen, die von Internetanbietern an private Haushalte vergeben wurden. Da die IPs wie gewöhnliche Heiminternetverbindungen wirken, vertrauen Websites ihnen und blockieren sie deutlich seltener als Rechenzentrums-IPs.",
  },
  {
    q: "Wie werden Proxidize Residential-IPs bezogen?",
    a: "Residential-IPs werden ethisch bezogen, über die eigene Bandwidth-Sharing-App sowie sorgfältig ausgewählte Partner-Apps. Jeder Datenverkehr wird nach strengen, einwilligungsbasierten Standards erfasst.",
  },
  {
    q: "Wie viele Residential-IPs hat Proxidize?",
    a: `${STATS_IPS_DE} Residential-IPs in ${STATS.countries} Ländern, mit Targeting bis auf Stadt- und ISP-Ebene.`,
  },
  {
    q: "Wofür kann ich Residential Proxies nutzen?",
    a: "Typische Anwendungsfälle sind Web Scraping, Preisüberwachung, SEO- und SERP-Tracking, KI- und LLM-Trainingsdatenerfassung, Marktforschung und Markenschutz. Erlaubt sind ausschließlich legale und ethische Anwendungsfälle gemäß unserer Acceptable Use Policy — Nutzung im Zusammenhang mit der Erwachsenenindustrie oder .gov-Websites ist nicht gestattet.",
  },
  {
    q: "Kann ich Proxidize Residential Proxies mit KI-Agenten nutzen?",
    a: "Ja. Rotierende Residential-IPs lassen den Datenverkehr von Agenten mit normaler Nutzeraktivität verschmelzen, wodurch automatisiertes Browsen und Task-Ausführung seltener blockiert werden. Der tatsächliche Datenverkehr des Agenten läuft über HTTP, HTTPS oder SOCKS5 — Playwright- und Puppeteer-Beispiele finden sich in der Entwickler-Dokumentation. Die REST-API und der Open-Source-Proxidize-MCP-Server sind separate Schnittstellen zur Verwaltung der Proxy-Ressourcen (IP-Rotation, Standortwechsel, Nutzungsüberwachung), auch direkt aus Claude Code, Claude Desktop oder Cursor.",
    link: { label: "Proxidize MCP-Server", href: "/tools/mcp-server" },
  },
  {
    q: "Wie funktioniert Geo-Targeting?",
    a: "Zielland, -stadt oder -ISP im Dashboard auswählen. Jede Anfrage läuft über den angegebenen Standort.",
    link: { label: "Residential-Proxy-Dokumentation", href: DOCS.residentialProxies },
  },
  {
    q: "Rotieren Sessions oder bleiben sie sticky?",
    a: "Beides. Die IP kann bei jeder Anfrage rotieren oder in einer sticky Session gehalten werden, je nach Workflow.",
    link: { label: "Residential-API-Referenz", href: DOCS.apiPerGbResidential },
  },
  {
    q: "Was passiert mit ungenutztem Datenvolumen?",
    a: "Es wird auf den nächsten Monat übertragen. Bei einer Kündigung bleibt das verbleibende Datenvolumen im Konto erhalten und verfällt nie. Es lässt sich jederzeit nutzen.",
  },
  {
    q: "Ist eine KYC-Verifizierung erforderlich?",
    a: "Ja. Jeder Kunde wählt zunächst einen Plan und schließt anschließend die Tier-1-KYC-Verifizierung (Know Your Customer) im eigenen Konto ab. Der Proxy-Zugriff bleibt gesperrt, bis die Verifizierung genehmigt ist.",
    link: { label: "KYC-Anforderungen", href: ROUTES.kyc },
  },
  {
    q: "Welche Protokolle werden unterstützt?",
    a: "HTTP, HTTPS und SOCKS5.",
  },
  {
    q: "Gibt es eine Geld-zurück-Garantie?",
    a: "Ja. Schriftlich innerhalb von 30 Tagen eingereichte Rückerstattungsanträge werden anerkannt, sofern auf dem einzelnen Proxy nicht mehr als 10 GB verbraucht wurden, begrenzt auf maximal zwei Rückerstattungen pro Kundenkonto.",
  },
  {
    q: "Sind Proxidize Residential Proxies dediziert oder statisch?",
    a: "Nein. Das Residential-Produkt bietet Zugriff auf einen rotierenden Residential-Proxy-Pool mit optionalen sticky Sessions. Eine sticky Session kann einen Exit vorübergehend halten, ist aber nicht dasselbe wie eine dauerhaft dedizierte, statische IP.",
  },
  {
    q: "Ist Proxidize ein seriöser Residential-Proxy-Anbieter?",
    a: "Ja. Proxidize ist mit 4,8/5 in verifizierten Bewertungen auf G2 und Trustpilot bewertet, verlangt von jedem Kunden eine KYC-Verifizierung und sichert jeden Plan mit einer 30-tägigen Geld-zurück-Garantie ab.",
    link: { label: "Verifizierte Bewertungen lesen", href: TRUSTPILOT_URL },
  },
  {
    q: "Gibt es Vertragsbindungen, Mindestlaufzeiten oder versteckte Gebühren?",
    a: "Keine langfristige Vertragsbindung und keine versteckten Gebühren. Pläne starten bei $25/Monat für 25 GB ($1/GB) und verlängern sich monatlich automatisch, bis gekündigt wird — jederzeit kündbar, ohne Vertragsstrafe, und ungenutztes Datenvolumen wird einfach übertragen. Der Plan lässt sich jederzeit nach oben oder unten anpassen.",
  },
  {
    q: "Kann ich gezielt UK-Residential-IPs ansteuern?",
    a: `Ja. Das Vereinigte Königreich ist eines von ${STATS.countries} unterstützten Ländern, und das Targeting lässt sich im Dashboard bis auf bestimmte UK-Städte und ISPs eingrenzen.`,
  },
];
